(function () {
	'use strict';

	angular
		.module('app.setup')
		.controller(
			'factoryOrderPolicyRecommendations',
			factoryOrderPolicyRecommendations
		);

	factoryOrderPolicyRecommendations.$inject = [
		'$rootScope',
		'$scope',
		'$timeout'
	];

	function factoryOrderPolicyRecommendations($rootScope, $scope, $timeout) {
		var vm = this;
	}
})();
